import { PopUpController } from './PopUpController';

export class GuiController {
	private scene;
	private popups;

	constructor(scene) {
		this.scene = scene;
		this.popups = [];
	}

	// message with yes, no, close buttons
	showMessageYNC(caption, message, context, okClickHandler, noClickHandler, closeClickHandler) {
		var pu = new PopUpController(this.scene, this);
		pu._show(this.scene.createGameMessagePUHandlerYNC);
		pu.wCont.depth = 1000;
		pu.captionText.text = caption;
		pu.messageText.text = message;

		if (okClickHandler == null && pu.okButton !== null) {
			pu.okButton.button.destroy();
		} else if (pu.okButton !== null) {
			pu.okButton.clickEvent.add(okClickHandler, context);
		}
		if (noClickHandler == null && pu.noButton !== null) {
			pu.noButton.button.destroy();
		} else if (pu.noButton !== null) {
			pu.noButton.clickEvent.add(noClickHandler, context);
		}
		if (closeClickHandler == null && pu.exitButton !== null) {
			pu.exitButton.button.destroy();
		} else if (pu.exitButton !== null) {
			pu.exitButton.clickEvent.add(closeClickHandler, context);
		}
		this.popups.push(pu);
		return pu;
	}

	// message with close button
	showMessage(caption, message, context, closeClickHandler) {
		var pu = new PopUpController(this.scene, this);
		pu._show(this.scene.createGameMessagePUHandler);
		pu.wCont.depth = 1000;
		pu.captionText.text = caption;
		pu.messageText.text = message;

		if (closeClickHandler == null && pu.exitButton !== null) {
			pu.exitButton.button.destroy();
		} else if (pu.exitButton !== null) {
			pu.exitButton.clickEvent.add(closeClickHandler, context);
		}
		this.popups.push(pu);
		return pu;
	}

	showShare(caption, message, context, closeClickHandler) {
		var pu = new PopUpController(this.scene, this);
		pu._show(this.scene.createGameMessagePUHandlerShare);
		pu.wCont.depth = 1000;
		pu.captionText.text = caption;
		pu.messageText.text = message;
		pu.pointsText.text = `Your score: ${this.scene.score}`;
		if (closeClickHandler == null && pu.exitButton !== null) {
			pu.exitButton.button.destroy();
		} else if (pu.exitButton !== null) {
			pu.exitButton.clickEvent.add(closeClickHandler, context);
		}
		this.popups.push(pu);
		return pu;
	}

	showPopUp(createPopupEvent) {
		var pu = new PopUpController(this.scene, this);
		pu._show(createPopupEvent);
		pu.wCont.depth = 1000;
		this.popups.push(pu);
		return pu;
	}

	closePopUp(popUp) {
		// console.log('this.popups.length before close: ' + this.popups.length)
		for (var i = 0; i < this.popups.length; i++) {
			if (this.popups[i] == popUp) {
				this.popups.splice(i, 1);
			}
		}
		popUp.wCont.destroy();
		// console.log('this.popups.length after close: ' + this.popups.length)
	}

	setInteractable(interactable) {
		this.popups.forEach(pu => {
			if (pu !== null) pu.setControlsInteractable(interactable);
		});
	}

	hasNoPopUp() {
		return this.popups.length === 0;
	}
}
